import { from, of } from 'rxjs';
import { AuthHttp } from '@common/services';
import { map, catchError } from 'rxjs/operators';
import { openNotification } from '@common/helpers';
import { getRequestParams } from '@helpers';

/**
 * GET /cost-centers?companyId=:id
 *
 * @param companyId
 */
export function getCostCentersAPI(companyId) {
  const url = `/cost-centers?companyId=${companyId}`;
  return from(AuthHttp.get(url));
}

/**
 * GET /applications
 *
 */
export function getApplicationsAPI(params) {
  const requestParams = getRequestParams(params);
  const url = `/applications?${requestParams}`;
  return from(AuthHttp.get(url));
}


/**
 * GET /api/applications/detail?id={id}
 *
 * @param id application id (Required)
 */
export function getApplicationDetails(id) {
  const url = `/applications/detail?id=${id}`;
  return from(AuthHttp.get(url)).pipe(
    map(res => {
      return res.data && res.data.allowedAppNames ? res.data.allowedAppNames : [];
    }),
    catchError(e => {
      const messages = e.response.data.messages;
      openNotification(
        'error',
        messages ? messages[0].message : 'Occurred error when get application details from server!'
      );
      return of([]);
    })
  );
}

/**
 * POST /applications
 * Update applications
 * @param
 */
export function updateApplications(id, apps) {
  return from(AuthHttp.put(`/applications/userApps?id=${id}`, apps))
    .pipe(
      catchError(error => {
        const messages = error.response.data.messages;
        openNotification(
          'error',
          messages ? messages[0].message : 'Occurred error when update applications!'
        );
        return of({});
      })
    );
}